import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ORG_ID, OrgContextDto, SessionDto } from '@data-access/bulk-operations-api';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { skipWhile } from 'rxjs/operators';

import { USER_SESSION } from '../core.module';

@Injectable({
  providedIn: 'root',
})
export class UserSessionService {
  private userSession = inject<SessionDto | null>(USER_SESSION, { optional: true });
  private router = inject(Router);

  companyId: string;
  private _userCompany: BehaviorSubject<OrgContextDto> = new BehaviorSubject(null);
  private userCompany$ = this._userCompany.asObservable();

  constructor() {
    this.initUserCompany();
  }

  getSession(): Observable<SessionDto> {
    return of(this.userSession);
  }

  getUserCompany() {
    return this.userCompany$.pipe(skipWhile((companyData) => !companyData));
  }

  private initUserCompany() {
    const orgId = inject(ORG_ID);
    if (!orgId) {
      console.error(`OrgId not found in path ${window.location.href}`);
      this.router.navigate(['/unauthorized']);
      return;
    }

    this.companyId = orgId;
    const userCompanyData = this.userSession?.availableContexts?.find(
      (context) => context.id.toString() === orgId,
    );

    this._userCompany.next(userCompanyData);
  }
}
